import React, {ReactElement, useState} from "react";
import classes from './Contact.module.scss'
import TextField from "../../components/TextField/TextField";
import Button from "../../components/Button/Button";
import {Formik, FormikErrors, FormikHelpers} from 'formik'
import {isValidEmail} from "../../helpers/emailValidator";
import Notification from "../../components/Notification/Notification";
import axios from 'axios'
import clsx from "clsx";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

interface IContactInfo {
	name: string,
	email: string,
	message: string
}

const api = process.env.REACT_APP_API;

const Contact = (): ReactElement => {
	const [open, setOpen] = useState(false);
	const [text, setText] = useState('');
	const initial: IContactInfo = {
		email: '',
		message: '',
		name: ''
	}

	const validate = (values: IContactInfo): FormikErrors<IContactInfo> => {
		const errors: FormikErrors<IContactInfo> = {};
		if (values.email === '')
			errors.email = 'Toto pole je povinné';
		if (!isValidEmail(values.email) && values.email !== '')
			errors.email = 'Neplatný email'
		if (values.name === '')
			errors.name = 'Toto pole je povinné';
		if (values.message === '')
			errors.message = 'Toto pole je povinné';
		return errors
	}

	const submit = (values: IContactInfo, helpers: FormikHelpers<IContactInfo>) => {
		helpers.setSubmitting(true)
		axios.post(api +"/contact", values).then(res => {
			if (res.data === 'OK') {
				setOpen(true)
				setText('Zpráva poslána')
				helpers.resetForm()
			} else throw Error('Invalid server response: ' + res.data)
		}).catch((err) => {
			setOpen(true)
			setText('Něco se pokazilo')
			console.error(err)
		})
			.finally(() => {
				setTimeout(() => setOpen(false), 3000)
				helpers.setSubmitting(false)
				ReactGA.event({
					category: 'User',
					action: "Send email"
				})
				ReactPixel.track('Contact')
			})
	}

	return (
		<div className={classes.root}>
			<h2>Kontaktní formulář</h2>
			<p className={classes.subText}>
				Zaujala Vás má práce? Máte zájem o spolupráci? Máte další dotazy? Pošlete mi zprávu
			</p>
			<Notification
				label={text}
				open={open}
				onClick={() => setOpen(false)}
			/>
			<Formik
				initialValues={initial}
				validate={validate}
				validateOnBlur={false}
				validateOnChange={false}
				validateOnMount={false}
				onSubmit={submit}
			>
				{({
					  values,
					  handleChange,
					  errors,
					  handleSubmit,
					  isSubmitting
				  }) => (
					<form className={clsx(classes.width, classes.font)} onSubmit={handleSubmit}>
						<div className={classes.upper}>
							<TextField
								value={values.name}
								className={classes.textArea}
								onChange={handleChange}
								name='name'
								error={!!errors.name}
								helperText={errors.name}
								placeholder='Jméno'
							/>
							<TextField
								value={values.email}
								className={classes.textArea}
								onChange={handleChange}
								name='email'
								error={!!errors.email}
								helperText={errors.email}
								placeholder='Email'
							/>
						</div>
						<div className={classes.lower}>
							<TextField
								className={classes.lowerTextArea}
								value={values.message}
								onChange={handleChange}
								name='message'
								error={!!errors.message}
								helperText={errors.message}
								placeholder='Zpráva'
								multiline
							/>
						</div>
						<Button
							className={classes.button}
							label='Odeslat'
							type='submit'
							disabled={isSubmitting}
						/>
					</form>
				)}
			</Formik>
		</div>
	)
}

export default Contact;